import React from "react";
import styles from "./Step5_Calculation.module.scss";
import Button from "../ui/Button/Button";
import InfoIcon from "../../assets/icons/info-circle.svg";
import Spinner from "../ui/Spinner/Spinner";

const Step5Calculation = ({ onNextStep, calculationResult, quizData }) => {
  if (!calculationResult) {
    return <Spinner />;
  }

  const { totalPrice, breakdown, details, recivedInput } = calculationResult;
  const { totalGovFee, totalHonorar, searchFee: breakdownSearchFee } = breakdown;
  const { govFee, colorFee, baseHonorar, extraHonorarForClasses, searchFee = breakdownSearchFee, needsSearch } = details || {};
  const { classCount, applierCount, hasColor, servicePackage } = recivedInput;

  const packageName = 
    servicePackage === "premium" ? "Premium" : 
    servicePackage === "plus" ? "Plus" : "Standard";

  const isSearchIncluded = needsSearch === true || searchFee > 0;

  // Base honorar stage 1 amounts
  const baseFirstStage = 
    servicePackage === "premium" ? 23000 :
    servicePackage === "plus" ? 12000 : 5500;
  
  const totalFirstStageHonorar = baseFirstStage + (extraHonorarForClasses || 0);

  const secondStageHonorar = 
    servicePackage === "premium" ? 2000 :
    servicePackage === "plus" ? 2000 : 1500;

  let paymentSchedule;
  if (isSearchIncluded) {
    paymentSchedule = (
      <p className={styles.paymentSchedule}>
        <strong>Перший етап: 3 000 грн</strong> — оплата попередньої юридичної перевірки ТМ (перед початком робіт).
        <br />
        <strong>Другий етап: {totalFirstStageHonorar.toLocaleString("uk-UA")} грн</strong> — перед підготовкою та поданням заявки до УКРНОІВІ.
        <br />
        <strong>Третій етап: {secondStageHonorar.toLocaleString("uk-UA")} грн</strong> — після отримання рішення від УКРНОІВІ.
      </p>
    );
  } else {
    paymentSchedule = (
      <p className={styles.paymentSchedule}>
        <strong>Перший етап: {totalFirstStageHonorar.toLocaleString("uk-UA")} грн</strong> — перед початком робіт та поданням заявки.
        <br />
        <strong>Другий етап: {secondStageHonorar.toLocaleString("uk-UA")} грн</strong> — після отримання рішення від УКРНОІВІ.
      </p>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.subtitle}>
          Ось повна вартість реєстрації вашої ТМ на основі зроблених вами виборів.
        </p>
      </div>

      <div className={styles.calculationBlock}>
        {/* Services Cost */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Вартість наших послуг</h2>
          <div className={styles.sectionContent}>
            <div className={styles.row}>
              <span className={styles.label}>
                Базова вартість пакета "{packageName}"
              </span>
              <span className={styles.value}>
                {baseHonorar.toLocaleString("uk-UA")} грн
              </span>
            </div>
            {extraHonorarForClasses > 0 && (
              <div className={styles.row}>
                <span className={styles.label}>Доплата за додаткові класи</span>
                <span className={styles.value}>
                  {extraHonorarForClasses.toLocaleString("uk-UA")} грн
                </span>
              </div>
            )}
            {isSearchIncluded && (
              <div className={styles.row}>
                <span className={styles.label}>Попередня юридична перевірка ТМ</span>
                <span className={styles.value}>
                  {(3000).toLocaleString("uk-UA")} грн
                </span>
              </div>
            )}
            <div className={styles.divider}></div>
            <div className={styles.totalRow}>
              <span className={styles.totalLabel}>Всього за послуги</span>
              <span className={styles.totalValue}>
                {totalHonorar.toLocaleString("uk-UA")} грн
              </span>
            </div>
          </div>
        </div>

        {/* Government Fees */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Державні збори та мита</h2>
          <div className={styles.sectionContent}>
            <div className={styles.row}>
              <span className={styles.label}>
                Збір за подання заявки ({classCount} класів, {applierCount}{" "}
                заявник)
              </span>
              <span className={styles.value}>
                {(govFee - 685).toLocaleString("uk-UA")} грн
              </span>
            </div>
            {hasColor && (
              <div className={styles.row}>
                <span className={styles.label}>
                  Доплата за подання кольорової ТМ
                </span>
                <span className={styles.value}>
                  {colorFee.toLocaleString("uk-UA")} грн
                </span>
              </div>
            )}
            <div className={styles.row}>
              <span className={styles.label}>
                Збір за публікацію про видачу свідоцтва
              </span>
              <span className={styles.value}>
                {(600).toLocaleString("uk-UA")} грн
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.label}>Держмито за видачу свідоцтва</span>
              <span className={styles.value}>
                {(85).toLocaleString("uk-UA")} грн
              </span>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.totalRow}>
              <span className={styles.totalLabel}>
                Всього державних платежів
              </span>
              <span className={styles.totalValue}>
                {totalGovFee.toLocaleString("uk-UA")} грн
              </span>
            </div>
          </div>
        </div>

        {/* Payment Procedure */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Порядок оплати</h2>
          <div className={styles.paymentInfo}>
            <p className={styles.paymentInfoImportant}>
              Важливо: Державні збори сплачуються вами самостійно за наданими
              реквізитами та не входять у вартість наших послуг.
            </p>
            {paymentSchedule}
          </div>
        </div>

        {/* Summary */}
        <div className={styles.summaryBlock}>
          <h3 className={styles.summaryTitle}>Загальна вартість "під ключ"</h3>
          <p className={styles.summaryTotal}>
            {totalPrice.toLocaleString("uk-UA")} грн
          </p>
        </div>

        {/* Terms Info */}
        <div className={styles.termsInfo}>
          <div className={styles.termsHeader}>
            <img src={InfoIcon} alt="info icon" className={styles.termsIcon} />
            <h4 className={styles.termsTitle}>
              Інформація щодо термінів реєстрації
            </h4>
          </div>
          <div className={styles.termsContent}>
            <p className={styles.termsSubtitle}>
              ПРОГНОЗОВАНИЙ ТЕРМІН: 15-16 місяців (при стандартній процедурі, без заперечень від УКРНОІВІ).
            </p>
            <p className={styles.termsText}>
              Наразі процедура прискореної реєстрації ТМ (за 7-9 місяців)
              офіційно скасована УКРНОІВІ (Українським національним офісом
              інтелектуальної власності та інновацій) і не існує. Стандартний
              термін розгляду заявки складає 15-16 місяці для всіх без винятку.{" "}
              <br></br> <br></br>Будь-які пропозиції зареєструвати ТМ значно
              швидше є введенням в оману. Ми вказуємо лише реалістичні терміни,
              щоб чесно керувати вашими очікуваннями.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.buttonWrapper}>
        <Button variant="primary" onClick={() => onNextStep({ totalPrice })}>
          Перейти до оформлення заявки
        </Button>
      </div>
    </div>
  );
};

export default Step5Calculation;
